import PropTypes from 'prop-types';
import TimetableMultiStops from './timetable_multi_stops';
import TimetableTwoStops from './timetable_two_stops';

const FerryTimetable = ({
  duration,
  disableSeasonalities,
  hiddenSeasonalityRouteIds,
  multiStop,
}) => {
  const TimeTable = multiStop ? TimetableMultiStops : TimetableTwoStops;

  return (
    <TimeTable
      duration={duration}
      disableSeasonalities={disableSeasonalities}
      hiddenSeasonalityRouteIds={hiddenSeasonalityRouteIds}
    />
  );
};

FerryTimetable.propTypes = {
  duration: PropTypes.string,
  disableSeasonalities: PropTypes.bool,
  hiddenSeasonalityRouteIds: PropTypes.arrayOf(PropTypes.number),
  multiStop: PropTypes.bool,
};

export default FerryTimetable;
